import React, { Component } from "react";
import { connect } from "react-redux";
import { searchProductsForPage } from "../../store/actions/product";
import PageTitle from "../../components/shared/PageTitle";
import CategoriesWidget from "../../components/shared/CategoriesWidget";
import CartWidget from "../../components/shared/CartWidget";
import SEO from "../../components/shared/SEO";
import VibrantProductCard from "../../components/VibrantProductCard";
import Loading from "../../components/shared/Loading";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { trackViewItemList, trackSearch } from "../../utils/analytics";

// URL'deki ?q=... parametresini bağımsız (React Router 4 uyumlu) şekilde okur
const parseQueryParam = (search) => {
  const raw = search || "";
  const match = raw.match(/[?&]q=([^&]*)/);
  if (!match) return "";
  return decodeURIComponent(match[1].replace(/\+/g, " "));
};

class Search extends Component {
  constructor(props) {
    super(props);
    // Filtre input'u boş başlar. Aranan terim header'daki arama kutusunda görünür;
    // buradaki input ise sonuçlar içinde süzme yapar (ör. "100" -> 100ml olanlar).
    this.state = {
      resultFilter: "",
      sortBy: "default",
    };
  }

  componentDidMount() {
    const q = parseQueryParam(this.props.location.search);
    if (q) {
      trackSearch(q);
      this.props.searchProductsForPage(q, 100);
    }
  }

  componentDidUpdate(prevProps) {
    const prevQ = parseQueryParam(prevProps.location.search);
    const currentQ = parseQueryParam(this.props.location.search);

    // URL'deki arama terimi değişti -> yeniden ara
    if (prevQ !== currentQ) {
      // Yeni aramada filtre ve sıralamayı sıfırla (filtre boş başlar)
      this.setState({ resultFilter: "", sortBy: "default" });
      if (currentQ) {
        trackSearch(currentQ);
        this.props.searchProductsForPage(currentQ, 100);
      }
    }

    // Sonuçlar yüklendiğinde analytics list görünümü
    if (
      !prevProps.product.searchPageProducts &&
      this.props.product.searchPageProducts &&
      this.props.product.searchPageProducts.length > 0
    ) {
      trackViewItemList(
        this.props.product.searchPageProducts,
        `Arama: ${currentQ}`
      );
    }
  }

  getFilteredAndSortedProducts = () => {
    const products = this.props.product.searchPageProducts;
    const { resultFilter, sortBy } = this.state;

    if (!products || products.length === 0) {
      return [];
    }

    let filtered = [...products];

    // Sonuçlar içinde süzme: ürün adında geçenleri listeler (ör. "100" -> 100ml)
    if (resultFilter) {
      const term = resultFilter.toLowerCase();
      filtered = filtered.filter(
        (product) => product.name && product.name.toLowerCase().includes(term)
      );
    }

    switch (sortBy) {
      case "featured":
        filtered = filtered.filter((product) => product.featured);
        break;
      case "deals":
        filtered = filtered.filter((product) => product.isDeal);
        break;
      case "new":
        filtered = filtered.filter((product) => {
          if (product.isNewProduct) return true;
          if (product.created_at) {
            const now = new Date();
            const createdDate = new Date(product.created_at);
            const daysDifference = (now - createdDate) / (1000 * 60 * 60 * 24);
            return daysDifference <= 7;
          }
          return false;
        });
        break;
      case "discounted":
        filtered = filtered.filter(
          (product) => product.sale_price && product.sale_price < product.price
        );
        break;
      case "price_asc":
        filtered.sort((a, b) => {
          const priceA = a.sale_price || a.price || 0;
          const priceB = b.sale_price || b.price || 0;
          return priceA - priceB;
        });
        break;
      case "price_desc":
        filtered.sort((a, b) => {
          const priceA = a.sale_price || a.price || 0;
          const priceB = b.sale_price || b.price || 0;
          return priceB - priceA;
        });
        break;
      case "newest":
        filtered.sort((a, b) => {
          const dateA = a.created_at ? new Date(a.created_at).getTime() : 0;
          const dateB = b.created_at ? new Date(b.created_at).getTime() : 0;
          return dateB - dateA;
        });
        break;
      default:
        break;
    }

    return filtered;
  };

  handleResultFilterChange = (e) => {
    this.setState({ resultFilter: e.target.value });
  };

  handleSortChange = (sortBy) => {
    this.setState({ sortBy });
  };

  getButtonStyle = (activeSort) => ({
    backgroundColor: this.state.sortBy === activeSort ? "#88c000" : "white",
    color: this.state.sortBy === activeSort ? "white" : "#666",
    border:
      this.state.sortBy === activeSort ? "1px solid #88c000" : "1px solid #ddd",
    borderRadius: "20px",
    padding: "6px 12px",
    fontSize: "12px",
    fontWeight: "500",
    transition: "all 0.3s ease",
    minWidth: "auto",
    whiteSpace: "nowrap",
    marginRight: "4px",
    marginBottom: "6px",
  });

  handleButtonHover = (e, activeSort, isEntering) => {
    if (this.state.sortBy !== activeSort) {
      if (isEntering) {
        e.target.style.backgroundColor = "#f0f8e8";
        e.target.style.borderColor = "#88c000";
        e.target.style.color = "#88c000";
      } else {
        e.target.style.backgroundColor = "white";
        e.target.style.borderColor = "#ddd";
        e.target.style.color = "#666";
      }
    }
  };

  render() {
    const { setting } = this.props;
    const { resultFilter, sortBy } = this.state;
    const query = parseQueryParam(this.props.location.search);

    const isFetching = this.props.product.searchPageFetching;
    const allResults = this.props.product.searchPageProducts;
    const displayProducts = this.getFilteredAndSortedProducts();
    const totalProducts = allResults ? allResults.length : 0;

    const siteTitle =
      setting && setting.setting && setting.setting.title
        ? setting.setting.title
        : "Botaniksan";

    const searchPageSEO = {
      title: query
        ? `"${query}" için arama sonuçları`
        : "Arama",
      description: query
        ? `${siteTitle} — "${query}" araması için bulunan ürünler.`
        : `${siteTitle} ürün araması`,
      type: "website",
      url: `/arama${query ? `?q=${encodeURIComponent(query)}` : ""}`,
      // Arama sonuç sayfaları arama motorlarınca indekslenmemeli
      noindex: true,
    };

    return (
      <React.Fragment>
        <SEO {...searchPageSEO} />
        <PageTitle title={query ? `"${query}" için arama sonuçları` : "Arama"} />

        <div
          className="container-fluid"
          style={{ paddingLeft: "15px", paddingRight: "15px" }}
        >
          {/* Başlık + Kontroller */}
          <div className="row" style={{ marginTop: 20 }}>
            <div className="col-12">
              <div
                style={{
                  background: "linear-gradient(135deg, #f0f8e8 0%, #fff 100%)",
                  border: "1px solid #e0e0e0",
                  borderRadius: "12px",
                  padding: "20px 15px",
                  marginBottom: 10,
                }}
              >
                {/* Arama başlığı */}
                <div className="row" style={{ marginBottom: 10 }}>
                  <div className="col-12">
                    <h1
                      style={{
                        fontSize: "20px",
                        fontWeight: 700,
                        color: "#333",
                        margin: 0,
                      }}
                    >
                      <FontAwesomeIcon
                        icon={["fas", "search"]}
                        style={{ color: "#88c000", marginRight: 8 }}
                      />
                      {query ? (
                        <React.Fragment>
                          "<span style={{ color: "#88c000" }}>{query}</span>"
                          için arama sonuçları
                        </React.Fragment>
                      ) : (
                        "Ürün Ara"
                      )}
                    </h1>
                  </div>
                </div>

                {/* Sonuçlarda filtre + sıralama */}
                <div className="row">
                  <div className="col-lg-4 col-md-5 col-sm-12 mb-3">
                    <div className="input-group">
                      <div className="input-group-prepend">
                        <span
                          className="input-group-text"
                          style={{
                            backgroundColor: "#88c000",
                            color: "white",
                            border: "none",
                          }}
                        >
                          <FontAwesomeIcon icon={["fas", "filter"]} />
                        </span>
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Sonuçlarda filtrele"
                        value={resultFilter}
                        onChange={this.handleResultFilterChange}
                        style={{
                          border: "1px solid #88c000",
                          borderLeft: "none",
                          fontSize: "14px",
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-lg-8 col-md-7 col-sm-12">
                    <div className="d-flex flex-wrap align-items-center justify-content-lg-end">
                      <button
                        className="btn btn-sm"
                        onClick={() => this.handleSortChange("featured")}
                        style={this.getButtonStyle("featured")}
                        onMouseEnter={(e) =>
                          this.handleButtonHover(e, "featured", true)
                        }
                        onMouseLeave={(e) =>
                          this.handleButtonHover(e, "featured", false)
                        }
                      >
                        <FontAwesomeIcon
                          icon={["fas", "star"]}
                          style={{ marginRight: "5px", fontSize: "11px" }}
                        />
                        Öne çıkan
                      </button>

                      <button
                        className="btn btn-sm"
                        onClick={() => this.handleSortChange("deals")}
                        style={this.getButtonStyle("deals")}
                        onMouseEnter={(e) =>
                          this.handleButtonHover(e, "deals", true)
                        }
                        onMouseLeave={(e) =>
                          this.handleButtonHover(e, "deals", false)
                        }
                      >
                        <FontAwesomeIcon
                          icon={["fas", "bolt"]}
                          style={{ marginRight: "5px", fontSize: "11px" }}
                        />
                        Fırsat Ürünü
                      </button>

                      <button
                        className="btn btn-sm"
                        onClick={() => this.handleSortChange("new")}
                        style={this.getButtonStyle("new")}
                        onMouseEnter={(e) =>
                          this.handleButtonHover(e, "new", true)
                        }
                        onMouseLeave={(e) =>
                          this.handleButtonHover(e, "new", false)
                        }
                      >
                        <FontAwesomeIcon
                          icon={["fas", "tag"]}
                          style={{ marginRight: "5px", fontSize: "11px" }}
                        />
                        Yeni ürün
                      </button>

                      <button
                        className="btn btn-sm"
                        onClick={() => this.handleSortChange("discounted")}
                        style={this.getButtonStyle("discounted")}
                        onMouseEnter={(e) =>
                          this.handleButtonHover(e, "discounted", true)
                        }
                        onMouseLeave={(e) =>
                          this.handleButtonHover(e, "discounted", false)
                        }
                      >
                        <FontAwesomeIcon
                          icon={["fas", "percent"]}
                          style={{ marginRight: "5px", fontSize: "11px" }}
                        />
                        İndirimli ürünler
                      </button>

                      <button
                        className="btn btn-sm"
                        onClick={() => this.handleSortChange("price_asc")}
                        style={this.getButtonStyle("price_asc")}
                        onMouseEnter={(e) =>
                          this.handleButtonHover(e, "price_asc", true)
                        }
                        onMouseLeave={(e) =>
                          this.handleButtonHover(e, "price_asc", false)
                        }
                      >
                        <FontAwesomeIcon
                          icon={["fas", "sort-amount-up"]}
                          style={{ marginRight: "5px", fontSize: "11px" }}
                        />
                        Fiyat artan
                      </button>

                      <button
                        className="btn btn-sm"
                        onClick={() => this.handleSortChange("price_desc")}
                        style={this.getButtonStyle("price_desc")}
                        onMouseEnter={(e) =>
                          this.handleButtonHover(e, "price_desc", true)
                        }
                        onMouseLeave={(e) =>
                          this.handleButtonHover(e, "price_desc", false)
                        }
                      >
                        <FontAwesomeIcon
                          icon={["fas", "sort-amount-down"]}
                          style={{ marginRight: "5px", fontSize: "11px" }}
                        />
                        Fiyat azalan
                      </button>

                      {(resultFilter || sortBy !== "default") && (
                        <button
                          className="btn btn-sm"
                          onClick={() => {
                            this.setState({
                              resultFilter: "",
                              sortBy: "default",
                            });
                          }}
                          style={{
                            backgroundColor: "#ff6b6b",
                            color: "white",
                            border: "1px solid #ff6b6b",
                            borderRadius: "20px",
                            padding: "6px 12px",
                            fontSize: "12px",
                            fontWeight: "500",
                            transition: "all 0.3s ease",
                            minWidth: "auto",
                            whiteSpace: "nowrap",
                            marginRight: "4px",
                            marginBottom: "6px",
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.backgroundColor = "#ff5252";
                            e.target.style.borderColor = "#ff5252";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.backgroundColor = "#ff6b6b";
                            e.target.style.borderColor = "#ff6b6b";
                          }}
                        >
                          <FontAwesomeIcon
                            icon={["fas", "times"]}
                            style={{ marginRight: "5px", fontSize: "11px" }}
                          />
                          Temizle
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Ana içerik + Sidebar */}
          <div className="row">
            <div className="col-md-3">
              <CartWidget />
              <CategoriesWidget />
            </div>

            <div className="col-md-9">
              <div className="row">
                {isFetching ? (
                  <div className="col-12 text-center py-5">
                    <Loading />
                  </div>
                ) : !query ? (
                  <div className="col-12 text-center py-5">
                    <div className="alert alert-info">
                      <h5>Arama yapın</h5>
                      <p>
                        Yukarıdaki arama kutusuna aradığınız ürünü yazıp "Ara"
                        butonuna basın.
                      </p>
                    </div>
                  </div>
                ) : displayProducts.length > 0 ? (
                  displayProducts.map((product, i) => (
                    <div
                      className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-4"
                      key={product._id || i}
                    >
                      <VibrantProductCard
                        {...product}
                        listIndex={i}
                        listName={`Arama: ${query}`}
                      />
                    </div>
                  ))
                ) : (
                  <div className="col-12 text-center py-5">
                    <div className="alert alert-info">
                      <h5>Ürün Bulunamadı</h5>
                      <p>
                        "
                        <strong>{query}</strong>" ile ilgili bir ürün bulunamadı.
                        Farklı bir kelimeyle tekrar deneyebilirsiniz.
                      </p>
                    </div>
                  </div>
                )}
              </div>

              {/* Sonuç sayısı */}
              {!isFetching && query && displayProducts.length > 0 && (
                <div className="row mt-4">
                  <div className="col-12">
                    <div className="alert alert-light text-center">
                      <strong>{displayProducts.length}</strong> ürün
                      gösteriliyor
                      {totalProducts !== displayProducts.length && (
                        <span> (toplam {totalProducts} sonuç içinden)</span>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ product, setting, category }) => {
  return { product, setting, category };
};

const mapDispatchToProps = { searchProductsForPage };

export default connect(mapStateToProps, mapDispatchToProps)(Search);



// WEBPACK FOOTER //
// ./src/routers/Search/index.js